import React, { useEffect, useRef } from "react";
import { round } from "lodash";
import { Recorder } from "./recording/Recorder";

import "./RecordingTimer.scss";

const circumference = 40 * 2 * Math.PI;

interface RecordingTimerProps {
  recorder: Recorder;
}
export const RecordingTimer: React.FC<RecordingTimerProps> = React.memo(
  ({ recorder }) => {
    let preCountdownRef = useRef<HTMLDivElement>(null);
    let timeParentRef = useRef<HTMLDivElement>(null);
    let timeSecondsRef = useRef<HTMLSpanElement>(null);
    let timeMillisRef = useRef<HTMLSpanElement>(null);
    let progressRef = useRef<SVGCircleElement>(null);

    useEffect(() => {
      let onPre = (t: number) => {
        preCountdownRef.current!.style.display = "";
        timeParentRef.current!.style.display = "none";
        preCountdownRef.current!.textContent = `${t}`;
      };
      let onTime = (t: number, max: number) => {
        preCountdownRef.current!.style.display = "none";
        timeParentRef.current!.style.display = "";

        let tSeconds = Math.floor(t);
        let tMillis = Math.floor((t - tSeconds) * 100);
        timeSecondsRef.current!.textContent = `${tSeconds}`;
        timeMillisRef.current!.textContent = `${tMillis}`;

        let percentComplete = round((t / max) * 100);
        let strokeDashOffset =
          circumference - (percentComplete / 100) * circumference;
        progressRef.current?.setAttribute(
          "stroke-dashoffset",
          `${strokeDashOffset}`
        );
      };

      recorder.on("preCountdown", onPre);
      recorder.on("recordingTimer", onTime);

      return () => {
        recorder.off("preCountdown", onPre);
        recorder.off("recordingTimer", onTime);
      };
    }, [recorder]);

    return (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 84 84"
          className="recordingTimer--progress"
        >
          <circle className="background" cx="42" cy="42" r="32" />
          <circle className="outline" cx="42" cy="42" r="40" />
          <circle
            ref={progressRef}
            className="progress"
            cx="42"
            cy="42"
            r="40"
            strokeDasharray={`${circumference} ${circumference}`}
            strokeLinecap="round"
          />
        </svg>
        <div className="recordingTimer">
          <div className="time time--recording" ref={timeParentRef}>
            <span className="timeSeconds--recording" ref={timeSecondsRef}>
              0
            </span>
            .
            <span className="timeMillis--recording" ref={timeMillisRef}>
              0
            </span>
          </div>
          <div className="time time--countdown" ref={preCountdownRef}>
            0
          </div>
        </div>
      </>
    );
  }
);
